var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackUpdatesImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 1324,
    viewBox: "0 0 213 1324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1703_26904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 213,
    height: 1324
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "track-updates-mask-elements"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 54,
    y: 6,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 54,
    y: 19,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 54,
    y: 32,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_2",
    y: 64,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_2",
    x: 54,
    y: 70,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_2",
    x: 54,
    y: 83,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_2",
    x: 54,
    y: 96,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_3",
    y: 128,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#5A5E79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 65_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_3",
    x: 54,
    y: 134,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#5A5E79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_3",
    x: 54,
    y: 147,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#5A5E79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_3",
    x: 54,
    y: 160,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#5A5E79"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_4",
    y: 192,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_4",
    x: 54,
    y: 198,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_4",
    x: 54,
    y: 211,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_4",
    x: 54,
    y: 224,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_5",
    y: 256,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_5",
    x: 54,
    y: 262,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_5",
    x: 54,
    y: 275,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_5",
    x: 54,
    y: 288,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_6",
    y: 320,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_6",
    x: 54,
    y: 326,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_6",
    x: 54,
    y: 339,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_6",
    x: 54,
    y: 352,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 72_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_7",
    y: 384,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_7",
    x: 54,
    y: 390,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_7",
    x: 54,
    y: 403,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_7",
    x: 54,
    y: 416,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_8",
    y: 448,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_8",
    x: 54,
    y: 454,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_8",
    x: 54,
    y: 467,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_8",
    x: 54,
    y: 480,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 74_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_9",
    y: 512,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_9",
    x: 54,
    y: 518,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_9",
    x: 54,
    y: 531,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_9",
    x: 54,
    y: 544,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_10",
    y: 576,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_10",
    x: 54,
    y: 582,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_10",
    x: 54,
    y: 595,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_10",
    x: 54,
    y: 608,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_11",
    y: 640,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_11",
    x: 54,
    y: 646,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_11",
    x: 54,
    y: 659,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_11",
    x: 54,
    y: 672,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_12",
    y: 704,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_12",
    x: 54,
    y: 710,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_12",
    x: 54,
    y: 723,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_12",
    x: 54,
    y: 736,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_13",
    y: 768,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_13",
    x: 54,
    y: 774,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_13",
    x: 54,
    y: 787,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_13",
    x: 54,
    y: 800,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_14",
    y: 832,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_14",
    x: 54,
    y: 838,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_14",
    x: 54,
    y: 851,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_14",
    x: 54,
    y: 864,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_15",
    y: 896,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_15",
    x: 54,
    y: 902,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_15",
    x: 54,
    y: 915,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_15",
    x: 54,
    y: 928,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_16",
    y: 960,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_16",
    x: 54,
    y: 966,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_16",
    x: 54,
    y: 979,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_16",
    x: 54,
    y: 992,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_17",
    y: 1024,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_17",
    x: 54,
    y: 1030,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_17",
    x: 54,
    y: 1043,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_17",
    x: 54,
    y: 1056,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_18",
    y: 1088,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_18",
    x: 54,
    y: 1094,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_18",
    x: 54,
    y: 1107,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_18",
    x: 54,
    y: 1120,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_19",
    y: 1152,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_19",
    x: 54,
    y: 1158,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_19",
    x: 54,
    y: 1171,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_19",
    x: 54,
    y: 1184,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_20",
    y: 1216,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_20",
    x: 54,
    y: 1222,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_20",
    x: 54,
    y: 1235,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_20",
    x: 54,
    y: 1248,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_21",
    y: 1280,
    width: 44,
    height: 44,
    rx: 5,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 66_20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_21",
    x: 54,
    y: 1286,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17_21",
    x: 54,
    y: 1299,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#34394E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_21",
    x: 54,
    y: 1312,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#34394E"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1703_26904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "track-updates-circle-bg",
    filter: "url(#filter0_f_1703_26904)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 211,
    r: 169,
    fill: "url(#paint0_radial_1703_26904)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1703_26904",
    x: -269.2,
    y: -87.2,
    width: 596.4,
    height: 596.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.6,
    result: "effect1_foregroundBlur_1703_26904"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1703_26904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29 211) rotate(90) scale(169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#0A0219"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackUpdatesImg);
export default __webpack_public_path__ + "static/media/TrackUpdatesImg.d95d84ed309b1c9691af19dd2a4dd3b6.svg";
export { ForwardRef as ReactComponent };